import React from 'react';

import './ShareLink.scss';

import { PostResponse } from '../../../../../types/models/posts';

import { TextShowcaseGroup } from '../../shared/TextShowcaseGroup/TextShowcaseGroup';
import { ItusLogo } from '../../../../../components/ItusLogo/ItusLogo';
import { PostCard } from '../../../../../components/cards/PostCard/PostCard';

interface IShareLink {
  demoPost: PostResponse;
};

export function ShareLink({ demoPost }: IShareLink) {
  return (
    <div className='ShareLink'>
      <TextShowcaseGroup isReverse={ false } areItemsCentered={ true }>
        <div className='ShareLink__text'>
          <p>This is the most pleasurable moment for you to be right and acknowledged!</p>
          <p>Press the "Copy Link" button to share the post with people you had clash of opinions.</p>
        </div>
        <div className='ShareLink__showcase'>
          <ItusLogo />
          <PostCard
            post={ demoPost }
            showCopyLinkButton={ true }
            isDemo={ true }
            isShowcase={ true }
          />

          <div className='ShareLink__comments'>
            Comments go here...
          </div>
        </div>
      </TextShowcaseGroup>
    </div>
  );
}
